"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStackGap = exports.inputBorderWidth = exports.helperTextHeight = exports.focusedInputBorderWidth = void 0;
/** Focused/Unfocused Styling */
const inputBorderWidth = 1;
exports.inputBorderWidth = inputBorderWidth;
const focusedInputBorderWidth = 2;
exports.focusedInputBorderWidth = focusedInputBorderWidth;
const inputStackGap = 0.5;
exports.inputStackGap = inputStackGap;
const helperTextHeight = 20;
exports.helperTextHeight = helperTextHeight;